import { MdOutlineSearch } from 'react-icons/md'

const PopularSearches = () => {
  return (
    <div>
      <p className="text-xs text-[#898CA8]">Búsquedas populares</p>

      <div className="flex flex-col gap-2.5 mt-2.5">
        <button
          type="button"
          className="w-full flex justify-start items-center gap-x-[10px]"
        >
          <MdOutlineSearch className="w-[18px] h-[18px] !text-lg !flex justify-center items-center text-text-primary" />

          <p className="text-xs text-text-primary">
            Salamanca 31, <span className="font-bold">Roma Norte</span>, CDMX
          </p>
        </button>
        <button
          type="button"
          className="w-full flex justify-start items-center gap-x-[10px]"
        >
          <MdOutlineSearch className="w-[18px] h-[18px] !text-lg !flex justify-center items-center text-text-primary" />

          <p className="text-xs text-text-primary">
            Salamanca 31, <span className="font-bold">Roma Norte</span>, CDMX
          </p>
        </button>
      </div>
    </div>
  )
}

export default PopularSearches
